import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  riskDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './dashBoard-detail-dialog.controller';
import template from './dashBoard-detail-dialog.html';
import dashboardIframe from '../dashboardIframe';

class dialogService {
  getOptions($event, {
    imageData,
    htmlData,
    widget,
  }) {
    return {
      controller,
      controllerAs: 'detailVM',
      locals: {
        imageData,
        htmlData,
        widget,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.ssrs.dashBoardDetail', [
  loaderService,
  alerts,
  confirmDialog,
  ssDialogService,
  riskDataService,
  dashboardIframe
])
  .service('dashBoardDetailDialog', dialogService)
  .name;
